import { LocalizationProvider } from "@mui/x-date-pickers";
import {
  CustomCalendarTodayOutlinedIcon,
  CustomDatePicker,
  StyledDateContainer,
} from "../common/StyledComponents/StyledFields";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { Typography } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

interface BasicDatePickerIProps {
  isDatePickerOpen?: boolean;
  setDatePickerOpen?: React.Dispatch<React.SetStateAction<any>>;
  date: string;
  handleDateChange: (field: string, value: any) => void;
  errorMessage: string | undefined;
  id?: string;
  readOnly?: boolean;
  name?: string;
  disableFuture?:boolean;
  disabled?: boolean;
  format?: string;
  maxDate?:any;
  minDate?:any;
}

const CustomDatePickerField = (
  props: BasicDatePickerIProps
): React.ReactElement => {
  const {
    date,
    handleDateChange,
    errorMessage,
    id,
    readOnly,
    name,
    disableFuture,
    disabled,
    format,
    minDate,
    maxDate
  } = props;

  const handleDateChangeInternal = (value: any) => {
    if (!readOnly && !disabled) {
      handleDateChange(name ? name : "date", value);
    }
  };

  return (
    <div style={{ minWidth: "100%", borderRadius: "8px" }}>
      <StyledDateContainer
        id={id}
        sx={{
          backgroundColor: "#FFF9E4",
          borderRadius: "8px",
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={["DateTimePicker"]}>
            <CustomDatePicker
              slots={{
                openPickerIcon: CustomCalendarTodayOutlinedIcon,
              }}
              slotProps={{
                inputAdornment: {
                  position: "end",
                },
              }}
              format={"MM-DD-YYYY"}
              value={date ? dayjs(date, format ? format: "MM-DD-YYYY") : ""}
              onChange={(value: any) => handleDateChangeInternal(value)}
              className={`${errorMessage ? 'error_text_field': 'text_field'} bg_white compact_fields`}
              readOnly={readOnly}
              disabled={readOnly ?? disabled}
              disableFuture={disableFuture}
              minDate={minDate}
              maxDate={maxDate}
            />
          </DemoContainer>
        </LocalizationProvider>
        {errorMessage ? (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessage}
          </Typography>
        ) : (
          ""
        )}
      </StyledDateContainer>
    </div>
  );
};

export default CustomDatePickerField;
